import React from 'react'
import { Link } from 'react-router-dom'
import Image from '../../../images/sellerpolicies/21.png'

const Shipping = () => {
  return (
    <div className='sp_details_wrapper'>
      <div className='sp_details_container'>
        <div className='sp_details_image'>
            <img src={Image} alt='policy'/>
        </div>
        <div className='sp_details_details'>
            <h2>SHIPPING</h2>
            <p>Seller will be obligated to ship their product with the KAAY’s appointed 3 PL service provider.</p>
            <p>Shipping charges are to be deducted by KAAY at the time of disbursement of payment to the seller upon the sale of the product.</p>
            <p>Following are the shipping charges</p>
            <table>
                <tr>
                    <th>Weight</th>
                    <th>Delivery</th>
                    <th>Packaging</th>
                    <th>Charges</th>
                </tr>
                <tr>
                    <td>0 to 5 kg</td>
                    <td>Nationwide</td>
                    <td>Flyer/box</td>
                    <td>Rs 49</td>
                </tr>
            </table>
            <p>The seller is obligated to fill in the correct weight, packaging, and estimated order fulfillment time for your product at the time of uploading or featuring the product on the KAAY platform.</p>
            <p>Following is the procedure seller has followed for shipping through KAAY.</p>
            <ul>
                <li>a.	Upon the order confirmation of the order by the customer notification will trigger in the order section of the seller’s dashboard.</li>
                <li>b.	Upon the order fulfillment the seller will request and download a postage label at the order section of the seller’s dashboard.</li>
                <li>c.	Seller has to print the postage label and paste it on the front side of the packed courier shipment.</li>
                <li>d.	Upon the printing of the postage label designated courier party will launch a confirmation call to the seller directly in 24 hours. And the seller is obligated to confirm the pickup in case of failure to do so shipping process will be suspended by KAAY.</li>
                <li>e.	Upon the confirmation by the seller next working day courier package will be collected from the pick address of the seller</li>
                <li>f.	Neither the 3PL nor KAAY shall be liable for any loss including but not limited to taxes and duties levied on the consignment arising due to confiscation of shipments by any government agencies due to lack of proper documents.</li>
            </ul>
            <p>Complete packing must be as per <Link to={'/sellerpolicies/packaging_guidelines'}>packing guidelines</Link>.</p>
        </div>
      </div>
    </div>
  )
}

export default Shipping
